import type { MouseEvent } from 'react';
import { CheckIcon } from '../../../assets/icons/icons';
import { cx } from '../../../utils/cx';
import styles from './Checkbox.module.scss';
import React from 'react';

interface CheckboxProps {
    checked: boolean;
    /** Часть строк выбрана — квадрат заливается приглушённым цветом. */
    indeterminate?: boolean;
    label: string;
    onChange: (event: MouseEvent<HTMLButtonElement>) => void;
}

export function Checkbox({ checked, indeterminate = false, label, onChange }: CheckboxProps) {
    return (
        <button
            type="button"
            role="checkbox"
            aria-checked={indeterminate ? 'mixed' : checked}
            aria-label={label}
            className={cx(styles.check, checked && styles.on, indeterminate && styles.some)}
            onClick={onChange}
        >
            <CheckIcon />
        </button>
    );
}
